import { useContext } from 'react'
import {
  EntryFormPageContext,
  EntryFormPageContextValue
} from './EntryFormPageContextProvider'

export const useEntryFormPage = (): EntryFormPageContextValue => {
  return useContext(EntryFormPageContext)
}
